export interface PagerSettings {
    /**
     * Enable/Disable pager option
     */
    pager: boolean;
}

export const pagerSettings: PagerSettings = {
    pager: true,
};
